<script setup lang="ts">
import { CAPABILITIES } from '../content/site-content';

import FeatureIcon from './FeatureIcon.vue';

/** «Cosa fa»: sei carte, una per cosa che Falasta toglie di mano a chi conduce. */
</script>

<template>
  <section id="cosa-fa" class="section">
    <div class="page">
      <div class="section__head">
        <span class="eyebrow">Cosa fa</span>
        <h2 class="section__title">Il banditore, il cronometro e il ragioniere</h2>
        <p class="section__lead">
          Le tre cose che in un’asta dal vivo fa qualcuno a mano — e che a mano si sbagliano —
          diventano il lavoro del server.
        </p>
      </div>

      <ul class="grid">
        <li v-for="capability in CAPABILITIES" :key="capability.id" class="tile">
          <span class="tile__icon"><FeatureIcon :name="capability.icon" /></span>
          <h3 class="tile__title">{{ capability.title }}</h3>
          <p class="tile__body">{{ capability.body }}</p>
        </li>
      </ul>
    </div>
  </section>
</template>

<style scoped>
.grid {
  display: grid;
  gap: 1rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.tile {
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: 1.25rem;
  background: var(--color-surface);
  box-shadow: var(--shadow-sm);
}

.tile__icon {
  display: grid;
  place-items: center;
  width: 2.5rem;
  height: 2.5rem;
  margin-bottom: 0.9rem;
  border-radius: var(--radius-md);
  background: var(--color-accent-soft);
  color: var(--color-accent-text);
}

.tile__title {
  font-size: 1.0625rem;
}

.tile__body {
  margin-top: 0.5rem;
  color: var(--color-muted);
  font-size: 0.9375rem;
}

@media (min-width: 40rem) {
  .grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 64rem) {
  .grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
</style>
